import {
  cilAccountLogout,
  cilAlignCenter,
  cilAlignLeft,
  cilAlignRight,
  cilApplicationsSettings,
  cilArrowBottom,
  cilArrowCircleLeft,
  cilArrowRight,
  cilArrowLeft,
  cilArrowTop,
  cilArrowThickToBottom,
  cilArrowThickToTop,
  cilBasket,
  cilBell,
  cilBellExclamation,
  cilBold,
  cilBookmark,
  cilBook,
  cilBuilding,
  cilCalculator,
  cilCalendar,
  cilCash,
  cilChart,
  cilChartPie,
  cilCheck,
  cilChevronLeft,
  cilChevronRight,
  cilCloudDownload,
  cilCode,
  cilCommentSquare,
  cilContact,
  cilContrast,
  cilCreditCard,
  cilCircle,
  cilCursor,
  cilDescription,
  cilDollar,
  cilDrop,
  cilEnvelopeClosed,
  cilEnvelopeOpen,
  cilFile,
  cilGraph,
  cilGrid,
  cilHome,
  cilHandshake,
  cilInbox,
  cilIndentDecrease,
  cilIndentIncrease,
  cilIndustry,
  cilInfo,
  cilInput,
  cilItalic,
  cilJustifyCenter,
  cilLanguage,
  cilLayers,
  cilLibraryBuilding,
  cilList,
  cilListRich,
  cilListNumbered,
  cilLocationPin,
  cilLockLocked,
  cilMagnifyingGlass,
  cilMap,
  cilMediaPlay,
  cilMediaRecord,
  cilMenu,
  cilMobile,
  cilMoney,
  cilMoon,
  cilNotes,
  cilOptions,
  cilPaperclip,
  cilPaperPlane,
  cilPen,
  cilPencil,
  cilPeople,
  cilPrint,
  cilPuzzle,
  cilReload,
  cilReportSlash,
  cilSave,
  cilSettings,
  cilShare,
  cilShareAll,
  cilShareBoxed,
  cilShortText,
  cilSpeech,
  cilSpeedometer,
  cilSpreadsheet,
  cilStar,
  cilSun,
  cilSync,
  cilTags,
  cilTask,
  cilTerrain,
  cilTrash,
  cilTruck,
  cilUnderline,
  cilUser,
  cilUserFemale,
  cilUserFollow,
  cilUserUnfollow,
} from '@coreui/icons';

import { signet } from './signet';
import { logo } from './logo';

export const iconSubset = {
  cilAccountLogout,
  cilAlignCenter,
  cilAlignLeft,
  cilAlignRight,
  cilApplicationsSettings,
  cilArrowBottom,
  cilArrowCircleLeft,
  cilArrowRight,
  cilArrowLeft,
  cilArrowTop,
  cilArrowThickToBottom,
  cilArrowThickToTop,
  cilBasket,
  cilBell,
  cilBellExclamation,
  cilBold,
  cilBookmark,
  cilBook,
  cilBuilding,
  cilCalculator,
  cilCalendar,
  cilCash,
  cilChart,
  cilChartPie,
  cilCheck,
  cilCircle,
  cilChevronLeft,
  cilChevronRight,
  cilCloudDownload,
  cilCode,
  cilCommentSquare,
  cilContact,
  cilContrast,
  cilCreditCard,
  cilCursor,
  cilDescription,
  cilDollar,
  cilDrop,
  cilEnvelopeClosed,
  cilEnvelopeOpen,
  cilFile,
  cilGraph,
  cilGrid,
  cilHome,
  cilHandshake,
  cilInbox,
  cilIndentDecrease,
  cilIndentIncrease,
  cilInfo,
  cilInput,
  cilIndustry,
  cilItalic,
  cilJustifyCenter,
  cilLanguage,
  cilLayers,
  cilLibraryBuilding,
  cilList,
  cilListRich,
  cilListNumbered,
  cilLocationPin,
  cilLockLocked,
  cilMagnifyingGlass,
  cilMap,
  cilMediaPlay,
  cilMediaRecord,
  cilMenu,
  cilMobile,
  cilMoney,
  cilMoon,
  cilNotes,
  cilOptions,
  cilPaperclip,
  cilPaperPlane,
  cilPen,
  cilPencil,
  cilPeople,
  cilPrint,
  cilPuzzle,
  cilReload,
  cilReportSlash,
  cilSave,
  cilSettings,
  cilShare,
  cilShareAll,
  cilShareBoxed,
  cilShortText,
  cilSpeech,
  cilSpeedometer,
  cilSpreadsheet,
  cilStar,
  cilSun,
  cilSync,
  cilTags,
  cilTask,
  cilTerrain,
  cilTrash,
  cilTruck,
  cilUnderline,
  cilUser,
  cilUserFemale,
  cilUserFollow,
  cilUserUnfollow,
  logo,
  signet,
};

export enum IconSubset {
  cilAccountLogout = 'cilAccountLogout',
  cilAlignCenter = 'cilAlignCenter',
  cilAlignLeft = 'cilAlignLeft',
  cilAlignRight = 'cilAlignRight',
  cilApplicationsSettings = 'cilApplicationsSettings',
  cilArrowBottom = 'cilArrowBottom',
  cilArrowCircleLeft = 'cilArrowCircleLeft',
  cilArrowRight = 'cilArrowRight',
  cilArrowLeft = 'cilArrowLeft',
  cilArrowTop = 'cilArrowTop',
  cilArrowThickToBottom = 'cilArrowThickToBottom',
  cilArrowThickToTop = 'cilArrowThickToTop',
  cilBasket = 'cilBasket',
  cilBell = 'cilBell',
  cilBold = 'cilBold',
  cilBook = 'cilBook',
  cilBookmark = 'cilBookmark',
  cilBuilding = 'cilBuilding',
  cilCalculator = 'cilCalculator',
  cilCalendar = 'cilCalendar',
  cilCash = 'cil-cash',
  cilChart = 'cilChart',
  cilChartPie = 'cilChartPie',
  cilCheck = 'cilCheck',
  cilChevronLeft = 'cilChevronLeft',
  cilChevronRight = 'cilChevronRight',
  cilCircle = 'cilCircle',
  cilCloudDownload = 'cilCloudDownload',
  cilCode = 'cilCode',
  cilCommentSquare = 'cilCommentSquare',
  cilContact = 'cilContact',
  cilContrast = 'cilContrast',
  cilCreditCard = 'cilCreditCard',
  cilCursor = 'cilCursor',
  cilDescription = 'cilDescription',
  cilDollar = 'cilDollar',
  cilDrop = 'cilDrop',
  cilEnvelopeClosed = 'cilEnvelopeClosed',
  cilEnvelopeOpen = 'cilEnvelopeOpen',
  cilFile = 'cilFile',
  cilGraph = 'cilGraph',
  cilGrid = 'cilGrid',
  cilHome = 'cilHome',
  cilHandshake = 'cilHandshake',
  cilInbox = 'cilInbox',
  cilIndentDecrease = 'cilIndentDecrease',
  cilIndentIncrease = 'cilIndentIncrease',
  cilInfo = 'cilInfo',
  cilInput = 'cilInput',
  cilItalic = 'cilItalic',
  cilJustifyCenter = 'cilJustifyCenter',
  cilLanguage = 'cilLanguage',
  cilLayers = 'cilLayers',
  cilLibraryBuilding = 'cilLibraryBuilding',
  cilList = 'cilList',
  cilListNumbered = 'cilListNumbered',
  cilLocationPin = 'cilLocationPin',
  cilLockLocked = 'cilLockLocked',
  cilMagnifyingGlass = 'cilMagnifyingGlass',
  cilMap = 'cilMap',
  cilMediaPlay = 'cilMediaPlay',
  cilMediaRecord = 'cilMediaRecord',
  cilMenu = 'cilMenu',
  cilMobile = 'cilMobile',
  cilMoney = 'cilMoney',
  cilMoon = 'cilMoon',
  cilNotes = 'cilNotes',
  cilOptions = 'cilOptions',
  cilPaperclip = 'cilPaperclip',
  cilPaperPlane = 'cilPaperPlane',
  cilPen = 'cilPen',
  cilPencil = 'cilPencil',
  cilPeople = 'cilPeople',
  cilPrint = 'cilPrint',
  cilPuzzle = 'cilPuzzle',
  cilReportSlash = 'cilReportSlash',
  cilSave = 'cilSave',
  cilSettings = 'cilSettings',
  cilShare = 'cilShare',
  cilShareAll = 'cilShareAll',
  cilShareBoxed = 'cilShareBoxed',
  cilShortText = 'cil-short-text',
  cilSpeech = 'cilSpeech',
  cilSpeedometer = 'cilSpeedometer',
  cilSpreadsheet = 'cilSpreadsheet',
  cilStar = 'cilStar',
  cilSun = 'cilSun',
  cilTags = 'cilTags',
  cilTask = 'cilTask',
  cilTerrain = 'cilTerrain',
  cilTrash = 'cilTrash',
  cilUnderline = 'cilUnderline',
  cilUser = 'cilUser',
  cilUserFemale = 'cilUserFemale',
  cilUserFollow = 'cilUserFollow',
  cilUserUnfollow = 'cilUserUnfollow',
  logo = 'logo',
  signet = 'signet',
}

export interface MaterialIcon {
  name: string;
  url: string;
}

export const iconMaterial: MaterialIcon[] = [
  {
    name: 'info',
    url: 'assets/svg/info-circle.svg',
  },
  {
    name: 'contract',
    url: 'assets/svg/contract.svg',
  },
  {
    name: 'contract-dark',
    url: 'assets/svg/contract-dark.svg',
  },
  {
    name: 'contract-light',
    url: 'assets/svg/contract-light.svg',
  },
  {
    name: 'contracted',
    url: 'assets/svg/contracted.svg',
  },
  {
    name: 'market',
    url: 'assets/svg/market.svg',
  },
  {
    name: 'market-light',
    url: 'assets/svg/market-light.svg',
  },
  {
    name: 'market-dark',
    url: 'assets/svg/market-dark.svg',
  },
  {
    name: 'posts',
    url: 'assets/svg/posts.svg',
  },
  {
    name: 'posts-light',
    url: 'assets/svg/posts-light.svg',
  },
  {
    name: 'posts-dark',
    url: 'assets/svg/posts-dark.svg',
  },
  {
    name: 'tracker',
    url: 'assets/svg/tracker.svg',
  },
  {
    name: 'tracker-light',
    url: 'assets/svg/tracker-light.svg',
  },
  {
    name: 'tracker-dark',
    url: 'assets/svg/tracker-dark.svg',
  },
  {
    name: 'lakal-logo-strip',
    url: 'assets/svg/lakal-logo-strip.svg',
  },
  {
    name: 'lakal-logo-dark',
    url: 'assets/svg/lakal-logo-dark.svg',
  },
  {
    name: 'lakal-logo-strip-white',
    url: 'assets/svg/lakal-logo-strip-white.svg',
  },
  {
    name: 'double-arrow-right',
    url: 'assets/svg/double-arrow-right.svg',
  },
  {
    name: 'double-arrow-left',
    url: 'assets/svg/double-arrow-left.svg',
  },
  {
    name: 'receipt',
    url: 'assets/svg/receipt.svg',
  },
  {
    name: 'box',
    url: 'assets/svg/box.svg',
  },
  {
    name: 'pallet',
    url: 'assets/svg/pallet.svg',
  },
  {
    name: 'delivery-van',
    url: 'assets/svg/delivery-van.svg',
  },
  {
    name: 'payments',
    url: 'assets/svg/payments.svg',
  },
  {
    name: 'schedule-send',
    url: 'assets/svg/schedule-send.svg',
  },
  {
    name: 'event',
    url: 'assets/svg/event.svg',
  },
  {
    name: 'store',
    url: 'assets/svg/store.svg',
  },
  {
    name: 'store-front',
    url: 'assets/svg/store-front.svg',
  },
  {
    name: 'agriculture',
    url: 'assets/svg/agriculture.svg',
  },
];
